// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7d9a9e15","703":"3de3b10f","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};